import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { contact } from "../mock";

export default function CtaBanner() {
  return (
    <section id="contact" className="py-14 bg-gradient-to-r from-teal-700 to-teal-600">
      <div className="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center justify-between gap-6 text-center lg:text-left">
        <div className="text-white">
          <p className="text-teal-200 font-semibold uppercase tracking-widest text-xs mb-2">Express Delivery &amp; Live Tracking</p>
          <h2 className="text-2xl sm:text-3xl font-extrabold">Ready to Ship Your Essential Medicines?</h2>
          <p className="mt-2 text-teal-100">Get a customized quote or talk to our live logistics specialists on WhatsApp now.</p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 shrink-0">
          <a href={`tel:${contact.phoneRaw}`} className="inline-flex items-center gap-2 bg-white text-teal-700 font-bold px-6 py-3.5 rounded-lg hover:bg-teal-50 transition-colors">
            <Phone className="w-5 h-5" /> {contact.phone}
          </a>
          <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3.5 rounded-lg transition-colors">
            <MessageCircle className="w-5 h-5" /> WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
}
